/**
 * MonitorEDUQuickButtons Component
 *
 * A floating quick actions button that appears in the lower right corner of the screen.
 * Features:
 * - Hover tooltip showing "Quick Actions"
 * - Click to expand menu with predefined links
 * - Opens links in new tabs
 * - Uses Grommet's built-in Menu component for reliability
 *
 * Usage: Simply import and render this component in your app
 * It will automatically position itself in the lower right corner
 */

import React from "react";
import { Box, Menu } from "grommet";
import { AppsRounded } from "grommet-icons";

const MonitorEDUQuickButtons = () => {
  const quickActions = [
    {
      label: "New America Sheets",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1pYu0Rra-60uwvn4AAjGX1Ccycq9qYC7LjFMvvpis_WI/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD A",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1KoJcDpg1T44oVXacmJ7BeLSE2Rdnl0b6WBiNl6Oye74/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD B",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1iIMDM90g4xfhRhkZg8okSWjMPOP90_2xuiK8yUdcWZo/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "POD C",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1YM95y7Iu1vuSRdvWtGK60zUY-V7WOS2QSxJ_vx7l2DA/edit?gid=0#gid=0",
          "_blank"
        );
      },
    },
    {
      label: "Schedule for proctors",
      onClick: () => {
        window.open(
          "https://docs.google.com/spreadsheets/d/1O7cHnpLbGwfUFXgpZK4D63786q9QdmyG0GJCSx4sLIk/edit?gid=701138413#gid=701138413",
          "_blank"
        );
      },
    },
    {
      label: "Batphone Support Line",
      onClick: () => {
        window.open("https://meet.google.com/otp-kgfc-zck", "_blank");
      },
    },
  ];

  return (
    <Box
      style={{
        position: "fixed",
        bottom: "20px",
        right: "0px",
        zIndex: 1000,
      }}
    >
      <Menu
        icon={<AppsRounded size="medium" color="white" />}
        items={quickActions}
        dropAlign={{ top: "bottom", right: "right" }}
        dropProps={{
          margin: { bottom: "50px", right: "0px" },
        }}
        tip="Quick Actions"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "8px 0px 0px 8px",
          backgroundColor: "black",
        }}
      />
    </Box>
  );
};

export default MonitorEDUQuickButtons;
